import { render, staticRenderFns } from "./CommodityAllocationList.vue?vue&type=template&id=1b1f2ed4&scoped=true&"
import script from "./CommodityAllocationList.vue?vue&type=script&lang=js&"
export * from "./CommodityAllocationList.vue?vue&type=script&lang=js&"
import style0 from "./CommodityAllocationList.vue?vue&type=style&index=0&id=1b1f2ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1f2ed4",
  null
  
)

export default component.exports